module.exports = __webpack_public_path__ + "img/title2.6974c46e.png";